import type { GetServerSideProps } from "next";
import getAppSettings from "../../lib/get-app-settings";
import loadEntityUpdates from "../../lib/load-entity-updates";
import sendSitemapXmlUrls from "../../lib/send-sitemap-xml-urls";

const SitemapFilePage = () => {
  return null;
};

export default SitemapFilePage;

export const getServerSideProps: GetServerSideProps =
  async function getServerSideProps(context) {
    try {
      const appSettings = await getAppSettings(context);
      if (!appSettings) {
        return { props: {} };
      }

      const base =
        appSettings.customDomain ||
        `${appSettings.helpCenterUrl}/${appSettings.slug}`;

      const updates = await loadEntityUpdates(appSettings.slug);
      const dynamicPaths = updates.map(([type, id, date]) => ({
        path: `${type === "article" ? "articles" : "categories"}/${id}`,
        date,
      }));
      const allPaths: Array<{ path: string; date: string }> = [
        { path: "", date: new Date().toISOString() },
        ...dynamicPaths,
      ];
      const links = allPaths.map(({ path, date }) => ({
        url: `${base}/${path}`,
        date: formatDate(date),
      }));

      sendSitemapXmlUrls(context.res, links);
    } catch (error) {
      console.error(error);
    }

    return { props: {} };
  };

function formatDate(date: string): string {
  // Remove milliseconds and add Z to specify the UTC timezone
  return date.split(".")[0] + "Z";
}
